import { render, staticRenderFns } from "./SportelloQuietanziantiView.vue?vue&type=template&id=a34c198c&"
import script from "./SportelloQuietanziantiView.vue?vue&type=script&lang=ts&"
export * from "./SportelloQuietanziantiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports